/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface Result
 */
export interface Result {
  /**
   *
   */
  basic: boolean;
  /**
   *
   */
  damageEstimation: boolean;
  /**
   *
   */
  arrivalTime: boolean;
}

/**
 * Check if a given object implements the Result interface.
 */
export function instanceOfResult(value: object): value is Result {
  if (!("basic" in value) || value["basic"] === undefined) return false;
  if (
    (!("damageEstimation" in (value as Record<string, any>)) &&
      !("damage_estimation" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["damageEstimation"] === undefined &&
      (value as Record<string, any>)["damage_estimation"] === undefined)
  )
    return false;
  if (
    (!("arrivalTime" in (value as Record<string, any>)) &&
      !("arrival_time" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["arrivalTime"] === undefined &&
      (value as Record<string, any>)["arrival_time"] === undefined)
  )
    return false;
  return true;
}

export function ResultFromJSON(json: any): Result {
  return ResultFromJSONTyped(json, false);
}

export function ResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): Result {
  if (json == null) {
    return json;
  }
  return {
    basic: json["basic"],
    damageEstimation: json["damage_estimation"],
    arrivalTime: json["arrival_time"],
  };
}

export function ResultToJSON(json: any): Result {
  return ResultToJSONTyped(json, false);
}

export function ResultToJSONTyped(
  value?: Result | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    basic: value["basic"],
    damage_estimation: value["damageEstimation"],
    arrival_time: value["arrivalTime"],
  };
}
